import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={80}
    height={80}
    viewBox="0 0 74.083 74.083"
    {...props}
  >
    <g
      id="backgroung-svg2"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      transform="matrix(1.0542 0 0 1.048 -1.9 -63.542)"
    >
      <ellipse
        id="backgroung-svg"
        cx={36.875}
        cy={95.989}
        strokeWidth={4.409}
        rx={32.861}
        ry={33.163}
      />
      <g strokeWidth={4.434}>
        <path d="M22.647 101.528c6.847 14.697 25.455 11.563 28.092-.295M42.108 89.005c-1.05-6.036 9.158-8.25 9.308-.094" />
        <path
          d="M23.362 88.907c-1.05-6.036 9.158-8.25 9.308-.094"
          opacity={0.98}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
